// Module
var code = "<div> <canvas class=\"qrgen\"></canvas> </div> ";
// Exports
export default code;